import { ERROR } from "../constants/types/alertType";
import {
  ORDER_DETAIL_RECEIVED,
  ORDER_HISTORY_RECEIVED,
  PATIENT_ORDER_HISTORY_RECEIVED,
} from "../constants/types/orderType";
import axios from "../utils/axios";

export const getOrders = (callback) => (dispatch) => {
  axios.get("ordersPractitioner?action=getUserOrders").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: ORDER_HISTORY_RECEIVED,
          payload: resp.data.orderList,
        });
      } else {
        dispatch({
          type: ORDER_HISTORY_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const getPatientOrders = (callback) => (dispatch) => {
  axios.get("ordersPatient?action=getUserOrders").then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: PATIENT_ORDER_HISTORY_RECEIVED,
          payload: resp.data.orderList,
        });
      } else {
        dispatch({
          type: PATIENT_ORDER_HISTORY_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const getOrderDetail = (id, callback) => (dispatch) => {
  axios
    .get(`ordersPractitioner?action=getUserOrderDetails&invoice_id=${id}`)
    .then(
      (resp) => {
        if (resp.data) {
          dispatch({
            type: ORDER_DETAIL_RECEIVED,
            payload: resp.data[0],
          });
          callback && callback();
        } else {
          dispatch({
            type: ORDER_DETAIL_RECEIVED,
            payload: null,
          });
          callback && callback();
        }
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
        callback && callback();
      }
    );
};

export const getPatientOrderDetail = (id, callback) => (dispatch) => {
  axios.get(`ordersPatient?action=getUserOrderDetails&invoice_id=${id}`).then(
    (resp) => {
      if (resp.data) {
        dispatch({
          type: ORDER_DETAIL_RECEIVED,
          payload: resp.data[0],
        });
        callback && callback();
      } else {
        dispatch({
          type: ORDER_DETAIL_RECEIVED,
          payload: null,
        });
        callback && callback();
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};
